var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.svgPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }